export const CREATE_CAMPAIGN_QUERY_PARAM = "createCampaign";
export const RESUME_CAMPAIGN_ONBOARDING_QUERY_PARAM = "resumeCampaign";
export const INITIAL_CREATIVES_QUERY_PARAM = "initialCreatives";
export const CREATE_CAMPAIGN_EDITOR_PATH = "/ads-campaign";
export const CREATE_CAMPAIGN_LIST_PATH = "/campaigns";
export const CREATE_CAMPAIGN_REQUIRED_MESSAGE_KEY = "fieldRequired";
export const CREATE_CAMPAIGN_PENDING_GENERATION_KEY =
  "pendingInitialGeneration";

export const CREATE_CAMPAIGN_PHASE = {
  SETUP: "setup",
  PLATFORM: "platform",
  GENERATING: "generating",
  ERROR: "error",
};

export const DEFAULT_CREATE_CAMPAIGN_FORM = {
  context: "",
  language: "",
  locations: {
    contexts: [],
    locations: [],
  },
  platforms: [],
  attachmentsFiles: [],
  fileNamesMapping: {},
};

export const CREATE_CAMPAIGN_MODAL_MAX_WIDTH = 750;

// Shared type scale for section titles, primary copy, and helper copy
// in the campaign creation modal.
export const CREATE_CAMPAIGN_SECTION_TITLE_SX = {
  fontWeight: 600,
  fontSize: "1rem",
  lineHeight: 1.5,
};

export const CREATE_CAMPAIGN_SECTION_TEXT_SX = {
  fontSize: "1rem",
  lineHeight: 1.5,
};

export const CREATE_CAMPAIGN_SECTION_HELPER_SX = {
  fontSize: "0.875rem",
  lineHeight: 1.43,
};
